import {BindPath, FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';
import {PropertyUtils} from '@mintdata/mint-kit/api/properties/PropertyUtils';

export type BindGroupName = string;

export class BindGroupConfig
{
    public readonly name:BindGroupName;
    public fieldPaths:Array<FieldPath>;

    public constructor(name:BindGroupName,
                       fieldPaths:Array<FieldPath>)
    {
        this.name = name;
        this.fieldPaths = fieldPaths;
    }
}

export interface IBindGroups
{
    [bindGroupName:string]:BindGroupConfig;
}

export class EditorConfig
{
    public readonly bindGroups:IBindGroups;

    constructor(bindGroups:IBindGroups)
    {
        this.bindGroups = bindGroups || {
            [BindPath.DEFAULT_BIND_GROUP_ID]: new BindGroupConfig(
                BindPath.DEFAULT_BIND_GROUP_ID,
                [BindPath.ROOT_FIELD_PATH]
            )
        };
    }
}

export function Editor(config:EditorConfig = new EditorConfig(null)):ClassDecorator
{
    return function <TFunction extends Function>(target:TFunction):TFunction
    {
        PropertyUtils.setEditorConfig(target, config);
        return target;
    };
}
